export default __webpack_public_path__ + "svg/calendar/2026/2/marzo.svg?34c8b6f5";